/***
 * Created on 2024/10/1
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useRef, useState} from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useOnChange} from "common/Hook";
import {getErrorMessage} from "common/ServiceCommon";
import TextInput from "../../common/form/text_input";
import {useMutation} from "@tanstack/react-query";
import {apiPost} from "../../../service/api";
import {useCountdown} from "../../../hook/countdown";


function ChinaAddPhoneStep1({state, dispatch, ...props}) {
    const { t } = useTranslation();
    const {seconds, setSeconds} = useCountdown(0);
    const {values, onChange, setValues} = useOnChange({
        mobile_number: '',
        country_code: '+86'
    });
    const modalRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState('');

    const sendMobileCode = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/send_mobile_code', data),
        onSuccess: data => {
            setSeconds(60);
            dispatch({type: 'currentStep', value: 2, inputValues: values});
        },
        onError: (error, variables, context) => {
            setErrorMessage(getErrorMessage(t, error.cause?.code));
        }
    });

    const onSubmit = () => {
        sendMobileCode.mutate(values);
    }

    useEffect(() => {
        if (/^\d{6,11}$/.test(values.mobile_number)) {
            modalRef.current.disableSubmitButton(false);
        }
        else {
            modalRef.current.disableSubmitButton(true);
        }
    }, [values.mobile_number]);

    return (
        <ModalDialog {...props} title={"@Add Your Phone Number@"} submitText={t('@Safety Comes First@')} hideCancel={true} ref={modalRef} submitAction={onSubmit}>
            <div className="dialog-content">
                <p>
                    {t('@According to article 24 of Cyber Security Law of the People\'s Republic of China, requiring that everyone who uses QNAP cloud services in China must provide their phone number for real-name verification.@')}
                </p>
                <p>
                    {t('@Once you have bind your account to your mobile phone, you can sign in QNAP account using your phone number and Email address. We will never use your phone number to send spam messages.@')}
                </p>

                <div className="dialog__form-group">
                    <label>{t('@Phone number@')}</label>
                    <div className="comp-input">
                        <div className="input-field--hybrid">
                            <div className="comp-select lock">
                                <div className="q-select cursor-pointer">
                                    <div className="q-select__label">中國 (+86)</div>
                                    <div className="q-select__arrow"></div>
                                </div>
                            </div>
                            <TextInput
                                noWrap={true}
                                minLength={6} maxLength={11} pattern="[0-9]*"
                                name='mobile_number'
                                value={values.mobile_number}
                                onChange={onChange}
                                inputMode="numeric"
                                required={true}
                                clearStyle={true}/>
                        </div>
                    </div>
                </div>

                {errorMessage && <p className="text-error">{errorMessage}</p>}
            </div>
        </ModalDialog>
    );
}

export default ChinaAddPhoneStep1;